module.exports = __webpack_public_path__ + "static/fiverfriday-b50a8864583f663840effc99ed5e00ca.jpeg";